import React from "react";
import { Table } from "antd";
import moment from "moment";

const AssociatedSpares = ({ dataSource }) => {
  const getSpareData = (id) => {
    window.open(`/autoadmin/customerspare/${id}`, "_blank");
  };

  const columns = [
    {
      title: "Order Date",
      dataIndex: "orderDate",
      key: "orderDate",
      render: (date) => moment(date).format("DD-MM-YYYY"),
    },
    {
      title: "Order Number",
      dataIndex: "orderNumber",
      key: "orderNumber",
    },
    {
      title: "Order Type",
      dataIndex: "orderType",
      key: "orderType",
    },
    {
      title: "Chassis No",
      dataIndex: ["soldVehicle", "chassisNo"],
      key: "chassisNo",
    },
    {
      title: "Register No",
      dataIndex: ["soldVehicle", "registerNo"],
      key: "registerNo",
      render: (reg) => reg || "N/A",
    },
    {
      title: "Engine No",
      dataIndex: ["soldVehicle", "engineNo"],
      key: "engineNo",
    },
  ];

  return (
    <div>
      <Table
        dataSource={dataSource}
        columns={columns}
        rowKey="id"
        pagination={false}
        onRow={(record) => {
          return {
            onClick: () => {
              getSpareData(record.id);
            },
          };
        }}
        style={{ cursor: "pointer" }}
      />
    </div>
  );
};

export default AssociatedSpares;
